// import merge from 'lodash/merge'
import enConfig from 'tdesign-vue-next/es/locale/en_US'
import zhConfig from 'tdesign-vue-next/es/locale/zh_CN'

export const getTDesignLocale = () => {
  const locale = import.meta.env.VITE_APP_I18N_LOCALE || 'en'
  const defaultLocal = locale === 'zh_CN' ? zhConfig : enConfig
  const globalConfig = Object.assign(defaultLocal, {
    calendar: {},
    table: {},
    pagination: {}
  })
  return globalConfig
}

export const getSystemConfig = () => {
  const config = {
    isElectron: window.electron ? true : false,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    isMock: import.meta.env.MODE === 'mock',
    baseUrl: import.meta.env.VITE_PUBLIC_PATH || '',
    apiUrl: import.meta.env.VITE_GLOB_API_URL as string,
    locale: (import.meta.env.VITE_APP_I18N_LOCALE || 'en') as string
    // localeConfig: getTDesignLocale()
  }
  return config
}
